import { render, staticRenderFns } from "./TestingSandbox.vue?vue&type=template&id=4ba15719&scoped=true&lang=html&"
import script from "./TestingSandbox.vue?vue&type=script&lang=js&"
export * from "./TestingSandbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba15719",
  null
  
)

export default component.exports